/* Shared removal rules; cart and drawer callers own requests and rendering. */
window.GiftBoxCartRemoval = {
  enqueue(operation) {
    const run = (this.operationQueue || Promise.resolve()).then(operation, operation);
    this.operationQueue = run.catch(() => {});
    return run;
  },

  role(item) {
    if (item?.properties?._october_reward === 'ghoulie-bag' && Number(item.properties._october_added_at) > 0) return 'bonus';
    const role = item?.properties?._promo_reward;
    const timestamp = Number(item?.properties?._promo_added_at);
    if (!Number.isFinite(timestamp) || timestamp <= 0) return '';
    if (role === 'monthly' || role === 'bonus') return role;
    if (role === 'mini' && String(item.properties._promo_selection_order || '').split(',')
      .some(value => Number.isFinite(Number(value)) && Number(value) > 0)) return role;
    return '';
  },

  plan(cart, key, identity = null) {
    if (!Array.isArray(cart?.items)) throw new Error('The current cart could not be confirmed.');
    let target = cart.items.find(item => item.key === key);
    // Shopify can change a line key after discounting. A queued click may follow
    // that change, so recover only a unique match for the exact managed reward.
    if (!target && identity?.addedAt && Number(identity.addedAt) > 0) {
      const matches = cart.items.filter(item => item.variant_id === identity.variantId &&
        this.role(item) === identity.role &&
        String(item.properties?._promo_added_at || item.properties?._october_added_at) === identity.addedAt);
      if (matches.length === 1) target = matches[0];
    }
    if (!target) return { updates: {} }; // A removed or changed key must never fall back to a line number.
    const role = this.role(target);
    const updates = { [target.key]: 0 };
    const attributes = {};
    if (role === 'bonus') {
      attributes._giftbox_bonus_opt_out = String(target.variant_id);
      cart.items.filter(item => this.role(item) === 'bonus' && item.variant_id === target.variant_id)
        .forEach(item => { updates[item.key] = 0; });
    } else if (role === 'monthly') {
      // The monthly figure and selected minis form one discount bundle.
      cart.items.filter(item => ['monthly', 'mini'].includes(this.role(item)))
        .forEach(item => { updates[item.key] = 0; });
    } else if (role === 'mini') {
      const otherMinis = cart.items.some(item => item.key !== target.key && this.role(item) === 'mini');
      if (!otherMinis) cart.items.filter(item => this.role(item) === 'monthly')
        .forEach(item => { updates[item.key] = 0; });
    }
    return { updates, ...(role === 'bonus' ? { attributes } : {}) };
  },
};
